import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Menu, X, Instagram } from "lucide-react";
import { useCart } from "../lib/cart";

export default function Header() {
  const { count, setOpen } = useCart();
  const [mobile, setMobile] = React.useState(false);

  const links = [
    { to: "/products", label: "Products" },
    { to: "/artist", label: "The Artist" },
    { to: "/about", label: "Manifesto" },
  ];

  return (
    <header className="glass-nav sticky top-0 z-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="block leading-none">
          <img src="/assets/kaiya_logo.png" alt="KaiyaYoga" className="h-14 md:h-16 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide hover:opacity-60 transition-opacity"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-4">
          <a
            href={process.env.REACT_APP_INSTAGRAM_URL}
            target="_blank" rel="noreferrer"
            data-testid="nav-instagram"
            className="hidden md:inline-flex p-2 hover:opacity-60"
            aria-label="Instagram"
          >
            <Instagram size={18} />
          </a>
          <button
            data-testid="header-cart-button"
            onClick={() => setOpen(true)}
            className="relative p-2 hover:opacity-60"
            aria-label="Cart"
          >
            <ShoppingBag size={18} />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-0.5 -right-0.5 text-[10px] rounded-full px-1.5 py-0.5 font-bold"
                style={{ background: "var(--kaiya-primary)", color: "var(--kaiya-bg)" }}
              >
                {count}
              </span>
            )}
          </button>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden p-2"
            onClick={() => setMobile(!mobile)}
            aria-label="Menu"
          >
            {mobile ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {mobile && (
        <div className="md:hidden border-t" style={{ borderColor: "var(--kaiya-border)" }}>
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <Link key={l.label} to={l.to} onClick={() => setMobile(false)} className="text-base">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
